import { type CityProfile } from '@core/city-profile/city-profile'

// the Turin demo profile — third demo city alongside Lyon and Lisbon.
// centre is Piazza Castello ; the UI runs in Italian (the app dictionaries already ship 'it',
// so a demotorino build is localised out of the box, unlike the Lisbon first pass).
export const kTorinoProfile: CityProfile = {
  id: 'torino',
  displayName: 'Mobilità Torino',
  brandLines: ['Mobilità', 'Torino'],
  center: [7.6869, 45.0703],
  zoom: 13.2,
  supervisionZoom: 12.5,
  locale: 'it-it',
  tz: 'Europe/Rome',
}
